export default __webpack_public_path__ + "images/453af79bd735aba9804a3da508b4695d-menu-dog-feed.svg";